const { isUndefined, cloneDeep } = require('lodash');

class BootstrapService {
    constructor($window) {
        this._data = $window.wowBootstrap || {};

        // A map of objects which are bootstrapped
        this.bootstrapped = {
            Config: 'ConfigRequest',
            Settings: 'SettingRequest',
            Shopper: 'ShopperRequest',
            ShopperDetails: 'ShopperDetailsRequest',
            ShopperBasicPreferences: 'BasicShopperPreferencesRequest',
            Categories: 'ListAllPiesCategoriesWithSpecialsRequest',
            RootCategories: 'ListTopLevelPiesCategories',
            Trolley: 'TrolleyRequest',
            DeliveryInfo: 'GetDeliveryInfoRequest',
            SpecialsGroups: 'SpecialsGroupListForShopRequest',
            SpecialsCategories: 'ListCategoriesForSpecialsRequest',
            RecipeCategories: 'ListRecipeCategoriesRequest',
            SavedLists: 'ListSavedListsRequest',
            SuggestedLists: 'ListSuggestedListsRequest',
            PastShops: 'ListPastShopsRequest',
            SearchPhraseActions: 'ListSearchPhraseActionsRequest',
            Panels: 'PanelsRequest',
            Subscriptions: 'SubscriptionsRequest',
            ShopperPreferences: 'ShopperPreferencesRequest',
        };
    }

    getBootstrappedData(key) {
        return cloneDeep(this._data[key]);
    }

    isBootstrapped(key) {
        return key in this._data && !!this._data[key];
    }

    getBootstrappedDataIfPresent(key) {
        return this.isBootstrapped(key)
            ? this.getBootstrappedData(key)
            : null;
    }

    setData(key, value, subKey) {
        if (isUndefined(subKey) || subKey === null || subKey === '') {
            this._data[key] = value;
        } else {
            this._data[key][subKey] = value;
        }
    }
}

BootstrapService.$inject = ['$window'];

module.exports = { BootstrapService };



// WEBPACK FOOTER //
// ./src/common/bootstrap/bootstrap.service.js